import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '@/core/http'
import { Response } from '@/core'
import { Experience } from './userExperience.types'

export const userExperienceApi = createApi({
  reducerPath: 'userExperienceApi',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    getUserExperience: builder.query<Experience[], void>({
      query: () => ({
        url: '/user-experience/get-experience',
        method: 'get',
      }),
      transformResponse: (response: Response<Experience[]>) => response.data.data,
    }),
  }),
})

export const { useGetUserExperienceQuery } = userExperienceApi

export default userExperienceApi.reducer
